import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { setLocalStorageItem } from "../localStorage/setLocalStorage";

const SeedBusinessRecord = async (uid) => {
  /**
   * Uses user id to get business record
   * Records business id, bid in local storage
   */
  const clientsCollection = await collection(db, "clients");
  const q = await query(clientsCollection, where("uid", "==", uid), limit(1));
  const businessSnapshot = await getDocs(q);
  let business = [];
  businessSnapshot.forEach((e) => business.push({ bid: e.id }));
  business = business.shift();
  let bid;

  if (business == null) {
    // if bid is null, it means it's an agent and bid lies in user object
    const userDoc = await doc(db, "users", uid);
    const userSnapshot = await getDoc(userDoc);
    const user = userSnapshot.data();
    bid = user.bid;
  } else bid = business.bid;

  /**
   * Storing user business id to local storage
   * every business data will be stored against this business id
   */

  setLocalStorageItem("bid", bid);

  return bid;
};

export default SeedBusinessRecord;
